module.exports = __webpack_public_path__ + "static/img/zixun.4a75b48a.png";